import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Message } from "@bbwt/classes";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { MessageService } from "primeng/api";
import { PatientInfo } from "./patient-info";
import { UserHelperService } from "@main/users/user-helper.service";

@Injectable()
export class IncompleteDataService extends BaseDataService {
    readonly url = "api/incomplete-manual-data";
    readonly automaticAccessUrl = "api/incomplete-automatic-data";

    constructor(
        httpClient: HttpClient,
        handlersFactory: HttpResponsesHandlersFactory,
        private messageService: MessageService,
        private readonly userHelperService: UserHelperService
    ) {
        super(httpClient, handlersFactory);
    }

    async hasIncompleteData(patientId: string) {
        if (this.userHelperService.isPatient) {
            return false;
        }

        const hasIncompleteData = await this.handleRequest(this.http.get<boolean>(`${this.url}/${patientId}`), this.responsesHandler);
        return hasIncompleteData;
    }

    getPatientInfo(patientId: string) {
        return this.handleRequest(this.http.get<PatientInfo>(`${this.url}/${patientId}/info`), this.responsesHandler);
    }

    async requestManualAccess(patientId: string) {
        await this.handleRequest(this.http.post<void>(`${this.url}/${patientId}/request-manual-access`, null), this.responsesHandler);

        this.messageService.add(
            Message.Success(
                "We have successfully sent your request to the Patient.  Once approved, you and your " +
                    "Organisation will have access to all the ORB Medical/Clinicial data for this Patient.",
                "Consent Requested"
            )
        );
    }

    async requestAutomaticAccess() {
        await this.handleRequest(this.http.post<void>(`${this.automaticAccessUrl}/request-automatic-access`, null), this.responsesHandler);
    }

    get responsesHandler() {
        return this.handlersFactory.getDefault({ showErrorMessage: false, showSuccessMessage: false });
    }
}
